import React from 'react';
import { RouteName } from 'components/dynamic-page/route-matchers';
import { useFeaturesContext } from 'contexts';
import { Logo } from 'components/header/shared';
import MobileSection from './components/MobileSection';
import { DesktopNavigation } from './components/DesktopNavigation';
import { HeaderContent } from './components/HeaderContent';
import { headerIds } from 'constants/test-constants';
import dataJSON from './data.json';
import styles from './style.module.scss';

type ZooHeaderProps = {
  routeName?: RouteName;
};

/**
 * ZooHeader Component
 * Main header component that uses HeaderContent for responsive layout management
 */
const ZooHeader = ({ routeName }: ZooHeaderProps) => {
  const { userLinks } = dataJSON;
  const { isSearchPanelOpen } = useFeaturesContext();

  return (
    <HeaderContent
      isSearchPanelOpen={isSearchPanelOpen}
      renderLogo={() => (
        <Logo 
          ariaLabel="Zoocasa header logo"
          logoClassName={styles.logo}
          testId={headerIds.zoocasaHeaderLogo}
        />
      )}
      renderDesktop={() => (
        <DesktopNavigation 
          userLinks={userLinks}
          routeName={routeName}
        />
      )}
      renderMobile={() => (
        <MobileSection 
          userLinks={userLinks}
          routeName={routeName}
        />
      )}
    />
  );
};

export default ZooHeader;
